/** IANA zone for calendar APIs (matches planner / training diary wall dates). */
export function clientIanaTimeZone() {
  try {
    const z = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return z && String(z).trim() ? String(z).trim() : 'UTC';
  } catch {
    return 'UTC';
  }
}
